import { render, staticRenderFns } from "./scholarFail.vue?vue&type=template&id=5fb0568d&scoped=true"
import script from "./scholarFail.vue?vue&type=script&lang=js"
export * from "./scholarFail.vue?vue&type=script&lang=js"
import style0 from "./scholarFail.vue?vue&type=style&index=0&id=5fb0568d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb0568d",
  null
  
)

export default component.exports